/* eslint-disable */
export default {
  status: 'Tila',
  acceptQueueCalls: 'Hyväksy jonon puhelut',
  callQueueDisabledReason: 'Asetusta hallinnoi yrityksesi järjestelmänvalvoja.',
  callQueueManagement: 'Hallitse jonoja',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
